import React from 'react'
import { Link } from 'gatsby'

const toggleMenu = () => {
  const menu = document.getElementById('menu')
  if (menu.classList.contains('open')) {
    setTimeout(toggleHorizontal, 500)
  } else {
    toggleHorizontal()
  }
  menu.classList.toggle('open')
  document.getElementById('toggle').classList.toggle('x')
}

const toggleHorizontal = () => {
  const x = []
  x.forEach.call(
    document.getElementById('menu').querySelectorAll('.custom-can-transform'),
    function (el) {
      el.classList.toggle('pure-menu-horizontal')
    }
  )
}

// const closeMenu = () => {
//   let menu = document.getElementById('menu')
//   if (menu.classList.contains('open')) {
//     toggleMenu()
//   }
// }

const clickToggleHandler = (e) => {
  toggleMenu()
  e.preventDefault()
}

const Header = ({ siteTitle }) => (
  <div className='header pure-g' id='menu'>
    <div className='pure-u-1 pure-u-md-1-3'>
      <div className='pure-menu header-title'>
        <Link to='/' className='pure-menu-heading custom-brand'>
          {siteTitle}
        </Link>
        <button
          className='custom-toggle'
          id='toggle'
          onClick={clickToggleHandler}
          aria-label='toggle menu'
        >
          <s className='bar' />
          <s className='bar' />
          <s className='bar' />
        </button>
      </div>
    </div>

    <div className='pure-u-1 pure-u-md-1-3'>
      <div className='pure-menu pure-menu-horizontal custom-can-transform'>
        <ul className='pure-menu-list'>
          <li className='pure-menu-item'>
            <Link to='/' className='pure-menu-link'>
              文章
            </Link>
          </li>
          <li className='pure-menu-item'>
            <Link to='/ranking' className='pure-menu-link'>
              博彩公司排名
            </Link>
          </li>
          <li className='pure-menu-item'>
            <Link to='/slotsgames/' className='pure-menu-link'>
              老虎机游戏
            </Link>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default Header
